import { DictionaryIllustrator_de_DE } from './de_DE';
import { DictionaryIllustrator_en_US } from './en_US';
import { DictionaryIllustrator_es_ES } from './es_ES';
import { DictionaryIllustrator_fr_FR } from './fr_FR';
import { DictionaryIllustrator_ja_JP } from './ja_JP';
import { DictionaryIllustrator_ko_KR } from './ko_KR';
import { DictionaryIllustrator_pt_BR } from './pt_BR';
import { DictionaryIllustrator_zh_CN } from './zh_CN';
import { DictionaryIllustrator_zh_TW } from './zh_TW';

export const IllustratorDictionaries = {
    de_DE: DictionaryIllustrator_de_DE,
    en_US: DictionaryIllustrator_en_US,
    es_ES: DictionaryIllustrator_es_ES,
    fr_FR: DictionaryIllustrator_fr_FR,
    ja_JP: DictionaryIllustrator_ja_JP,
    ko_KR: DictionaryIllustrator_ko_KR,
    pt_BR: DictionaryIllustrator_pt_BR,
    zh_CN: DictionaryIllustrator_zh_CN,
    zh_TW: DictionaryIllustrator_zh_TW,
};
